import React, { useState, useEffect } from "react";
import { Drawer, Layout, Menu, Button } from "antd";
import {
  Routes,
  Route,
  Link,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Navbar from "../Navbar";
import Banner from "../Banner/Banner";
import ContentHome from "../ContentHome";
import { MenuFoldOutlined } from "@ant-design/icons";
import "src/page/Public/hha-add.css";
import "src/page/Public/indexpublic.css";
import ParentTuLieu from "../TuLieu/ParentTuLieu";
import ParentGallery from "../Gallery/ParentGallery";
import ParentVideo from "../Video/ParentVideo";
import DetailPage from "../TuLieu/DetailPageTuLieu";
import DetailPageGallery from "../Gallery/DetailPageGallery";
import DetailPageVideo from "../Video/DetailPageVideo";
import FooterHome from "../FooterHome";

const { Header, Content, Sider, Footer } = Layout;

const HomeLayout: React.FC = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [keyAttribute, setKeyAttribute] = useState<string>();
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onClickOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const getMenuItems = () => {
    const baseItems = [
      {
        key: "trang-chu",
        label: <Link to="/trang-chu">Trang chủ</Link>,
      },
      {
        key: "tu-lieu",
        label: <Link to="/trang-chu/tu-lieu">Tư liệu</Link>,
      },
      {
        key: "hinh-anh",
        label: <Link to="/trang-chu/hinh-anh">Hình ảnh</Link>,
      },
      {
        key: "video",
        label: <Link to="/trang-chu/video">Video</Link>,
      },
      {
        key: "dang-nhap",
        label: <Link to="/dang-nhap">Quản trị</Link>,
      },
    ];

    if (windowWidth < 992 && !isDrawerOpen) {
      return [
        {
          key: "menu-toggle",
          label: (
            <Button onClick={onClickOpenDrawer}>
              <MenuFoldOutlined />
            </Button>
          ),
        },
        ...baseItems,
      ];
    }
    return baseItems;
  };

  const getKeyMenu = (key: any) => {
    const selectedKey = key.key || key;
    setKeyAttribute(key.key);
    switch (selectedKey) {
      case "trang-chu":
        setIsDrawerOpen(false);
        navigate("/trang-chu");
        break;
      case "tu-lieu":
        setIsDrawerOpen(false);
        navigate("/trang-chu/tu-lieu");
        break;
      case "hinh-anh":
        setIsDrawerOpen(false);
        navigate("/trang-chu/hinh-anh");
        break;
      case "video":
        setIsDrawerOpen(false);
        navigate("/trang-chu/video");
        break;
      case "dang-nhap":
        setIsDrawerOpen(false);
        navigate("/dang-nhap");
        break;
      case "menu-toggle":
        setKeyAttribute("trang-chu");
        setIsDrawerOpen(true);
        break;
      default:
        navigate("/");
    }
  };

  const keyPhu = (key: string) => {
    if (key === "chi-tiet" || /^\d+$/.test(key)) {
      const currentPath = window.location.pathname;
      const segments = currentPath.split("/");
      const desiredSegment = segments[2];
      return desiredSegment;
    } else {
      return key;
    }
  };

  useEffect(() => {
    const currentPath = window.location.pathname.split("/").pop();
    const documentTypes = ["tu-lieu", "video", "hinh-anh"];

    if (documentTypes.some((type) => currentPath?.startsWith(type))) {
      setKeyAttribute(currentPath);
    } else if (currentPath === "" || currentPath === "trang-chu") {
      localStorage.removeItem("currentMenuKey");
      setKeyAttribute("trang-chu");
    } else {
      setKeyAttribute(keyPhu(currentPath || ""));
    }
  }, [location.pathname]);

  return (
    <Layout className="qti-layout">
      <Header className="qti-header">
        <Banner />
        <div className="container">
          <Menu
            mode="horizontal"
            selectedKeys={[keyAttribute || "/"]}
            items={getMenuItems()}
            onClick={(key) => getKeyMenu(key)}
          />
        </div>
      </Header>
      <Layout>
        <div className="container">
          <Layout>
            <Drawer
              placement="left"
              className="custom-drawer"
              style={{ maxWidth: "280px", boxShadow: "none" }}
              closable={true}
              onClose={() => setIsDrawerOpen(false)}
              open={isDrawerOpen}
            >
              <div className="container">
                <Menu
                  mode="vertical"
                  selectedKeys={[keyAttribute || "/"]}
                  items={getMenuItems()}
                  onClick={(key) => getKeyMenu(key)}
                />
              </div>
              {/* <Navbar keyAttribute={keyAttribute || undefined} setIsDrawerOpen={setIsDrawerOpen} /> */}
            </Drawer>
            {keyAttribute !== "trang-chu" &&
              keyAttribute !== "/trang-chu" &&
              keyAttribute !== "/" &&
              windowWidth > 992 && (
                <Sider
                  width="20%"
                  breakpoint="lg"
                  collapsedWidth="0"
                  collapsed={collapsed}
                  onCollapse={setCollapsed}
                  style={{ padding: "10px 0 0 0", background: "transparent" }}
                >
                  <Navbar
                    keyAttribute={keyAttribute || undefined}
                    setIsDrawerOpen={setIsDrawerOpen}
                  />
                </Sider>
              )}
            <Content
              style={
                keyAttribute !== "trang-chu" && keyAttribute !== "/trang-chu"
                  ? { padding: "10px" }
                  : { padding: "10px 0 0 0" }
              }
            >
              <Routes>
                <Route index element={<ContentHome />} />
                {/* Tư liệu */}
                <Route path="/tu-lieu" element={<ParentTuLieu />} />
                <Route
                  path="/tu-lieu/idnhomtulieu/:id"
                  element={<ParentTuLieu />}
                />
                <Route path="/tu-lieu/:id/chi-tiet" element={<DetailPage />} />
                <Route path="/hinh-anh" element={<ParentGallery />} />
                <Route
                  path="/hinh-anh/idnhomtulieu/:id"
                  element={<ParentGallery />}
                />
                <Route
                  path="/hinh-anh/:id/chi-tiet"
                  element={<DetailPageGallery />}
                />
                <Route path="/video" element={<ParentVideo />} />
                <Route
                  path="/video/idnhomtulieu/:id"
                  element={<ParentVideo />}
                />
                <Route
                  path="/video/:id/chi-tiet"
                  element={<DetailPageVideo />}
                />
              </Routes>
            </Content>
          </Layout>
        </div>
      </Layout>
      <Footer style={{ textAlign: "center" }}>
        Bản quyền © 2024 Ban Dân Tộc
      </Footer>
    </Layout>
  );
};

export default HomeLayout;
